import request from './../utils/request.js'

// 注册方法
export function inquiry_pcba_save(data) {
  return request({
    url: '/post/inquiry.inquiry_pcba:save',
    method: 'post',
    data: data
  })
}
export function upload(data) {
  return request({
    url: '/post/inquiry.inquiry_pcba:upload_file_ret_name',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  })
}

